import {QueryResultInfo} from "./QueryResultInfo";
import {StatisticsInfo} from "./StatisticsInfo";

/// <summary>
/// 结果是统计类型的信息
/// </summary>
export class ResultStatisticsTypeInfo extends QueryResultInfo {

	constructor() {
		super();
		 this.statistics = null;
	}



	/**
		 *获得统计类型的信息 
		 * @param jsonObj
		 * @return 
		 */
	static GetResultStatisticsTypeInfo(jsonObj) {
		let statisTypeInfo=null;
		if(jsonObj==null)return statisTypeInfo;

		statisTypeInfo=new ResultStatisticsTypeInfo();
		statisTypeInfo.SetResultBasicInfo(jsonObj);
		statisTypeInfo.statistics =StatisticsInfo.GetStatisticsInfo(jsonObj.statistics);
		
		return statisTypeInfo;
	}


}//end ResultStatisticsTypeInfo

